import { useEffect, useRef } from 'react'
import { FolderOpen, Video, Image as ImageIcon, Heart, Users } from 'lucide-react'
import { ButtonTabs } from '@/components/ui'

export type AssetFilterType = 'all' | 'video' | 'image' | 'favorites' | 'characters'

interface AssetFiltersProps {
  value: AssetFilterType
  onChange: (value: AssetFilterType) => void
  isLoading?: boolean
}

const tabs: { id: string; label: string; icon: React.ElementType; value: AssetFilterType }[] = [
  { id: 'all', value: 'all', label: 'All', icon: FolderOpen },
  { id: 'characters', value: 'characters', label: 'Characters', icon: Users },
  { id: 'favorites', value: 'favorites', label: 'Favorites', icon: Heart },
  { id: 'video', value: 'video', label: 'Videos', icon: Video },
  { id: 'image', value: 'image', label: 'Images', icon: ImageIcon },
]

export function AssetFilters({ value, onChange, isLoading }: AssetFiltersProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  // Auto-scroll to active tab on mobile
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    if (scrollContainer) {
      const activeButton = scrollContainer.querySelector('[data-active="true"]')
      if (activeButton) {
        activeButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      }
    }
  }, [value])

  return (
    <div
      ref={scrollContainerRef}
      className="overflow-x-auto scrollbar-hide -mx-6 px-6 md:mx-0 md:px-0 md:overflow-visible"
    >
      <ButtonTabs
        items={tabs}
        value={value}
        onChange={onChange}
        disabled={isLoading}
      />
    </div>
  )
}
